﻿$.fn.dxCtrlContentSmsEnvoi = function custom_dxCtrlContentSmsEnvoi(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentsmsenvoi dx-ctrl");
        this.createInstance(new cdxCtrlContentSmsEnvoi(this, option));
    }
    return this;
}

window.NOMBRE_DESTINATAIRE_A_SMS_MAX = 20
window.idxEditorSms = 0
window.cdxCtrlContentSmsEnvoi = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var jauge = null

    var editorSms = null
    var $TxtArea = null
    var $TxtAreaEmoji = null
    var $DivEntete = null
    var $DivBt = null
    var $DivDetail = null
    //var dxGrid = null

    var $DivContent = null
    //var $DivMobile = null
    var dxCtrlMobile = null
    var $DivContentSmsStat = null
    var $DivContentSmsDest = null
    var $DivContentSmsVue = null
    var $DivContentSmsClick = null
    var $DivContentSmsDesinscription = null
    var $DivContentSmsBounce = null
    function mConstruit() {
        container.empty()
        container.css({
            "padding": "0",
            "position": "relative",
            "width": "100%",
            "height": "100%"
        })

        if (option.data.date_envoi != null && option.data.tracking == "1") {
            $("<div style='height:100%'/>").appendTo(container).dxCtrlContentEnvoiTracking({
                bddCtrl: option.bddCtrl,
                data: option.data
            }).dxCtrlContentEnvoiTracking("instance")
        } else {
            $("<div style='height:100%'/>").appendTo(container).dxCtrlContentEnvoiMailing({
                bddCtrl: option.bddCtrl,
                data: option.data,
                type: "sms",
                showPrevi: true,
                //onDemandeEnvoi: function () {
                //    //on enregistre les crédits de chaque message
                //    option.bddCtrl.getObjet(option.data).objetMetier.mSend(function () {
                //        page.mRemovePopup(option.data)
                //    })
                //}
            }).dxCtrlContentEnvoiMailing("instance")
        }
        mRempliBt()


        //$DivContent = $("<div style='width:100%;height:100%;z-index:0;'/>").appendTo(container)
        //idxEditorSms += 1

        //jauge = $("<div/>").appendTo($DivContent).dxCtrlJauge({}).dxCtrlJauge("instance")
        //jauge.mShow();

        //$DivBt = $("<div style='position:absolute;top:0;right:0;padding-right:15px;height:calc(100% - 20px);text-align:right;z-index:10;'/>").appendTo(container)



        //var dxTabs = null
        //if (option.data.date_envoi != null && option.data.tracking == "1") {
        //    var ds = ["Statistiques", "Destinataires", "Vues", "Clicks", "Désinscriptions", "Bounces", "Message"]
        //    dxTabs = $("<div style='margin-top:20px;width:100%;'/>").appendTo($DivContent).dxTabs({
        //        dataSource: ds,
        //        selectedItem: ds[0],
        //        itemTemplate: function (itemData, itemIndex, itemElement) {
        //            itemElement.text(itemData)
        //            itemElement.parent().attr("title", itemData)
        //            itemElement.css("postion", "relative")
        //            switch (itemData) {
        //                case "Statistiques":
        //                    itemElement.html("<i class='fas fa-chart-pie' style='font-size:160%;'></i>")
        //                    break;
        //                case "Destinataires": case "Vues": case "Clicks": case "Désinscriptions": case "Bounces":
        //                    var divCpt = $("<div style='padding:3px 5px;text-align:center;background-color:green;border-radius:50%;position:absolute;top:0px;right:0;min-width:18px;opacity:0.6;font-size:80%;'/>").appendTo(itemElement.parent())
        //                    if (itemData == "Destinataires") {
        //                        itemElement.html("<i class='fas fa-users' style='font-size:160%;'></i>")
        //                        option.bddCtrl.mAjaxCall({ command: "getdatas", nomtable: "lstcomdest", sql: "select * from com_destinataire where id_table_com=" + option.bddCtrl.getObjet(option.data).mGetTable().id_table + " and id_com=" + option.data.id_com_sms_envoi }, function (data) {
        //                            if (typeof data.lstcomdest == 'undefined') data.lstcomdest = []
        //                            divCpt.text(data.lstcomdest.length)
        //                        })
        //                    } else {
        //                        mCharge()
        //                        function mCharge() {
        //                            if (container.closest("body").length == 0) return
        //                            switch (itemData) {
        //                                case "Vues":
        //                                    itemElement.html("<i class='fas fa-eye' style='font-size:160%;'></i>")
        //                                    option.bddCtrl.mAjaxCall({ command: "getdatas", nomtable: "lstvue", sql: "select * from com_sms_envoi_tracking_vue where id_com_sms_envoi=" + option.data.id_com_sms_envoi }, function (data) {
        //                                        if (typeof data.lstvue == 'undefined') data.lstvue = []
        //                                        divCpt.text(data.lstvue.length)
        //                                    })
        //                                    break;
        //                                case "Clicks":
        //                                    itemElement.html("<i class='fas fa-arrow-pointer' style='font-size:160%;'></i>")
        //                                    option.bddCtrl.mAjaxCall({ command: "getdatas", nomtable: "lstclick", sql: "select * from com_sms_envoi_tracking_click where id_com_sms_envoi=" + option.data.id_com_sms_envoi }, function (data) {
        //                                        if (typeof data.lstclick == 'undefined') data.lstclick = []
        //                                        divCpt.text(data.lstclick.length)
        //                                    })
        //                                    break;
        //                                case "Désinscriptions":
        //                                    itemElement.html("<i class='fas fa-user-secret' style='font-size:160%;'></i>")
        //                                    option.bddCtrl.mAjaxCall({ command: "getdatas", nomtable: "lstDesinscription", sql: "select * from com_destinataire where id_table_com=" + option.bddCtrl.getObjet(option.data).mGetTable().id_table + " and id_com=" + option.data.id_com_sms_envoi + " and not date_desinscription is null" }, function (data) {
        //                                        if (typeof data.lstDesinscription == 'undefined') data.lstDesinscription = []
        //                                        divCpt.text(data.lstDesinscription.length)
        //                                    })
        //                                    break;
        //                                case "Bounces":
        //                                    itemElement.html("<i class='fas fa-ghost' style='font-size:160%;'></i>")
        //                                    option.bddCtrl.mAjaxCall({ command: "getdatas", nomtable: "lstBounce", sql: "select * from com_destinataire where id_table_com=" + option.bddCtrl.getObjet(option.data).mGetTable().id_table + " and id_com=" + option.data.id_com_sms_envoi + " and not date_bounce is null" }, function (data) {
        //                                        if (typeof data.lstBounce == 'undefined') data.lstBounce = []
        //                                        divCpt.text(data.lstBounce.length)
        //                                    })
        //                                    break;
        //                            }
        //                            if (option.data.date_envoi == null || Math.abs(diffdate(option.data.date_envoi, parametre.dateNow, "d")) < 10) window.setTimeout(function () { mCharge() }, 5000)
        //                        }
        //                    }
        //                    break;
        //            }
        //        },
        //        onSelectionChanged: function (e) {
        //            jauge.mShow()
        //            switch (e.addedItems[0]) {
        //                case "Statistiques": mRempliStat(); break;
        //                case "Destinataires": mRempliDestinataire(); break;
        //                case "Vues": mRempliVue(); break;
        //                case "Clicks": mRempliClick(); break;
        //                case "Désinscriptions": mRempliDesinscription(); break;
        //                case "Bounces": mRempliBounce(); break;
        //                case "Message": mRempliMessage(); break;
        //            }
        //        }
        //    }).dxTabs("instance")
        //}

        //$DivContentSmsStat = $("<div style='position:absolute;width:100%;height:calc(100% - " + ((!dxTabs) ? "0" : (dxTabs.element().innerHeight() + 20)) + "px);padding-top:5px;display:none;'/>").appendTo($DivContent)
        //$DivContentSmsDest = $("<div style='position:absolute;width:100%;height:calc(100% - " + ((!dxTabs) ? "0" : (dxTabs.element().innerHeight() + 20)) + "px);display:none;padding-top:5px;display:none;'/>").appendTo($DivContent)
        //$DivContentSmsVue = $("<div style='position:absolute;width:100%;height:calc(100% - " + ((!dxTabs) ? "0" : (dxTabs.element().innerHeight() + 20)) + "px);display:none;padding-top:5px;display:none;'/>").appendTo($DivContent)
        //$DivContentSmsClick = $("<div style='position:absolute;width:100%;height:calc(100% - " + ((!dxTabs) ? "0" : (dxTabs.element().innerHeight() + 20)) + "px);display:none;padding-top:5px;display:none;'/>").appendTo($DivContent)
        //$DivContentSmsDesinscription = $("<div style='position:absolute;width:100%;height:calc(100% - " + ((!dxTabs) ? "0" : (dxTabs.element().innerHeight() + 20)) + "px);display:none;padding-top:5px;display:none;'/>").appendTo($DivContent)
        //$DivContentSmsBounce = $("<div style='position:absolute;width:100%;height:calc(100% - " + ((!dxTabs) ? "0" : (dxTabs.element().innerHeight() + 20)) + "px);display:none;padding-top:5px;display:none;'/>").appendTo($DivContent)

        ////dxCtrlMobile = $("<div style='position:absolute;width:100%;height:calc(100% - " + ((!dxTabs) ? "0" : (dxTabs.element().innerHeight() + 20)) + "px);display:none;justify-content:center;align-items:center;'/>").appendTo($DivContent).dxCtrlContentSmsMobile({
        ////    bddCtrl: option.bddCtrl,
        ////    data: option.data
        ////}).dxCtrlContentSmsMobile("instance")

        //dxCtrlMobile = $("<div style='height:100%'/>").appendTo($DivContent).dxCtrlContentEnvoiMailing({
        //    bddCtrl: option.bddCtrl,
        //    data: option.data,
        //    type:"sms",
        //    showPrevi:true
        //}).dxCtrlContentEnvoiMailing("instance")

        ////$DivMobile = $("<div style='position:absolute;width:100%;height:calc(100% - " + ((!dxTabs) ? "0" : (dxTabs.element().innerHeight() + 20)) + "px);display:none;justify-content:center;align-items:center;'/>").appendTo($DivContent)

        //////var $DivMobileInterne = $("<div style='width:100%;height:100%;max-height:750px;max-width:360px;position:relative;'/>").appendTo($DivMobile)
        ////var $DivMobileInterne = $("<div style='width:100%;height:100%;max-width:360px;position:relative;'/>").appendTo($DivMobile)
        ////var $DivTop = $("<div style='position:absolute;top:0;right:0;height:70px;width:100%;background-color:black;border-radius:30px 30px 0 0;display:flex;justify-content:center;align-items:center;'/>").appendTo($DivMobileInterne)
        ////$("<div style='width:25px;height:8px;background-color:white;border-radius:5px;'/>").appendTo($DivTop)
        ////var $DivLeft = $("<div style='position:absolute;top:70px;right:0;height:calc(100% - 230px);width:20px;background-color:black;'/>").appendTo($DivMobileInterne)
        ////var $DivRight = $("<div style='position:absolute;top:70px;left:0;height:calc(100% - 230px);width:20px;background-color:black;'/>").appendTo($DivMobileInterne)
        ////var $DivBottom = $("<div style='position:absolute;bottom:125px;right:0;height:90px;width:100%;background-color:black;border-radius:0 0 30px 30px;display:flex;justify-content:center;align-items:center;margin-bottom:5px;'/>").appendTo($DivMobileInterne)
        ////$DivDetail = $("<div style='font-family:barlow condensed;position:absolute;bottom:0;text-align:center;opacity:1;font-size:120%;width:100%;'></div>").appendTo($DivMobileInterne)
        ////var $DivRond = $("<div style='width:40px;height:40px;background-color:white;border-radius:50%;'/>").appendTo($DivBottom)

        ////var $DivContainer = $("<div style='position:absolute;top:70px;left:20px;width:calc(100% - 40px);height:calc(100% - 220px);'/>").appendTo($DivMobileInterne)
        ////var $DivContainerInner = $("<div style='width:100%;height:100%;position:relative;'/>").appendTo($DivContainer)
        ////$DivEntete = $("<div style='width:100%;'/>").appendTo($DivContainerInner)

        ////var $DivGrid = $("<div style='position:absolute;top:" + $DivEntete.innerHeight() + "px;height:calc(100% - " + ($DivEntete.innerHeight() + 200 + 15) + "px);z-index:0;' class='containergrid'/>").appendTo($DivContainerInner)

        //mRempliBt()


        ////var $DivContainerEditor = $("<div style='position:absolute;bottom:75px;max-height:calc(100% - " + ($DivEntete.innerHeight() + 15) + "px);height:140px;width:100%;border-top:" + theme.border + ";'/>").appendTo($DivContainerInner)

        ////$DivEditor = $("<div id='iddd" + idxEditorSms + "' style='height:100%;'/>").appendTo($DivContainerEditor)
        ////txtSaved = new cSendSms(option.bddCtrl, ((option.data.body_txt == null) ? "" : option.data.body_txt)).mGetTextWithoutSeparateurLink()
        ////$TxtArea = $("<textarea id='idemoji" + idxEditorSms + "' placeholder='Saisissez votre message...' style='height:100%;width:100%;'>" + txtSaved + "</textarea>").appendTo($DivEditor)
        ////if (!(option.data.date_envoi == null || option.data.id_type_classement == 11)) {
        ////    $TxtArea.attr("disabled", "true")
        ////} else {
        ////    $TxtArea.emojioneArea({
        ////        pickerPosition: "top",
        ////        tonesStyle: "bullet",
        ////        searchPlaceholder: "Rechercher...",
        ////        events: {
        ////            onLoad: function () {
        ////                window.setTimeout(function () {
        ////                    $TxtAreaEmoji = $TxtArea[0].emojioneArea
        ////                    Me.isDirty(false)
        ////                    mChange()
        ////                }, 0)
        ////            }
        ////        }
        ////    });
        ////}

        ////resizeObserver.mAdd($DivEntete, function () {
        ////    //$DivContainerEditor.css("height", "calc(100% - " + ($DivEntete.innerHeight() + 15) + "px)")
        ////    $DivGrid.css({
        ////        top: $DivEntete.innerHeight() + "px",
        ////        height: "calc(100% - " + ($DivEntete.innerHeight() + 200 + 15) + "px)"
        ////    })
        ////})

        //$DivCurrent = dxCtrlMobile.element()
        //if (dxTabs) {
        //    mRempliStat()
        //} else { dxCtrlMobile.element().css("display", "flex") }

        //Me.isDirty(false)

        //mChange()
        //jauge.mHide()

    }

    var $DivCurrent = null
    //function mRempliStat() {
    //    var oldDivCurrent = $DivCurrent
    //    oldDivCurrent.stop()
    //    oldDivCurrent.fadeOut(300, function () { if (!oldDivCurrent.is(dxCtrlMobile.element()) && !oldDivCurrent.is($DivCurrent)) oldDivCurrent.empty() })
    //    $DivCurrent = $DivContentSmsStat
    //    $("<div style='width:100%;height:100%;'/>").appendTo($DivCurrent).dxCtrlContentComEnvoiStat({
    //        bddCtrl: option.bddCtrl,
    //        data: option.data
    //    })
    //    $DivCurrent.fadeIn(300, function () { jauge.mHide() })
    //}
    //function mRempliDestinataire() {
    //    var oldDivCurrent = $DivCurrent
    //    oldDivCurrent.stop()
    //    oldDivCurrent.fadeOut(300, function () { if (!oldDivCurrent.is(dxCtrlMobile.element()) && !oldDivCurrent.is($DivCurrent)) oldDivCurrent.empty() })
    //    $DivCurrent = $DivContentSmsDest
    //    $("<div/>").appendTo($DivCurrent).dxCtrlGridComDestinataire({
    //        bddCtrl: option.bddCtrl,
    //        context_grid: "list_destinataire_tracking",
    //        noDataText: "Aucun destinataire",
    //        id_table_com: option.bddCtrl.getObjet(option.data).mGetTable().id_table,
    //        id_com: option.bddCtrl.getObjet(option.data).cle(),
    //        typeData: "comdestsms",
    //        allowCheck: false,
    //        allowFilter: true,
    //        orderBounce: false,
    //        allowGroup: true,
    //        showColumnHeaders: true,
    //        getItemsToolBar: function (dxGridComDest) {
    //            var lst = []
    //            lst.push({
    //                location: 'before',
    //                template: function (itemData, itemIndex, itemElement) {
    //                    option.bddCtrl.getObjet("dossier").objetMetier.mGetButtonToolBarAddDansDossier(itemElement,function () { return dxGridComDest.mGetDxGrid() }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_destinataire inner join (select value as id from string_split('%lstid%',',')) as tab ON com_destinataire.id_com_destinataire=tab.id where not com_destinataire.id_destinataire is null")
    //                }
    //            })
    //            lst.push({
    //                location: 'before',
    //                template: function (itemData, itemIndex, itemElement) {
    //                    option.bddCtrl.getObjet("pipeline").objetMetier.mGetButtonToolBarAddDansPipeline(itemElement,function () { return dxGridComDest.mGetDxGrid() }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_destinataire inner join (select value as id from string_split('%lstid%',',')) as tab ON com_destinataire.id_com_destinataire=tab.id where not com_destinataire.id_destinataire is null")
    //                }
    //            })
    //            //lst.push(option.bddCtrl.getObjet("dossier").objetMetier.mGetButtonToolBarAddDansDossier(function () { return dxGridComDest.mGetDxGrid() },"select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_destinataire inner join (select value as id from string_split('%lstid%',',')) as tab ON com_destinataire.id_com_destinataire=tab.id where not com_destinataire.id_destinataire is null"))
    //            //lst.push(option.bddCtrl.getObjet("pipeline").objetMetier.mGetButtonToolBarAddDansPipeline(function () { return dxGridComDest.mGetDxGrid() },"select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_destinataire inner join (select value as id from string_split('%lstid%',',')) as tab ON com_destinataire.id_com_destinataire=tab.id where not com_destinataire.id_destinataire is null"))
    //            return lst
    //            //return [{
    //            //    location: 'before',
    //            //    template: function (itemData, itemIndex, itemElement) {
    //            //        $("<div/>").appendTo(itemElement).dxCtrlButton({
    //            //            icon: "fas fa-clapperboard",
    //            //            icon2: "fas fa-plus",
    //            //            colorIcone2: theme.colorBtIcon2,
    //            //            opacityIcone2: "0.9",
    //            //            txtTooltip: "Ajouter les destinataires<br/>affichés<br/>dans un dossier",
    //            //            onClick: function (e) {
    //            //                var lstId = ""
    //            //                dxGridComDest.mGetDxGrid().mGetLstTraitementData().forEach(function (dataGrid) {
    //            //                    lstId += ((lstId.length > 0) ? "," : "") + dataGrid.id
    //            //                })
    //            //                if (lstId.length > 0) {
    //            //                    option.bddCtrl.mAjaxCall({ command: "getdatas", nomtable: "lst", sql: "select com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_destinataire inner join (select value as id from string_split('" + lstId + "',',')) as tab ON com_destinataire.id_com_destinataire=tab.id" }, function (data) {
    //            //                        var lstnewdossierelement = ((typeof data.lst == 'undefined') ? [] : data.lst)
    //            //                        if (lstnewdossierelement.length > 0) {
    //            //                            option.bddCtrl.getObjet("dossier").objetMetier.mAddDansDossier(e.component.element(), lstnewdossierelement)
    //            //                        }
    //            //                    })
    //            //                } else { mNotify("Aucun élément", "warning", 3000) }
    //            //            }
    //            //        }).dxCtrlButton("instance")
    //            //    }
    //            //}]
    //        }
    //    }).dxCtrlGridComDestinataire("instance")
    //    $DivCurrent.fadeIn(300, function () { jauge.mHide() })
    //}
    //function mRempliVue() {
    //    var oldDivCurrent = $DivCurrent
    //    oldDivCurrent.stop()
    //    oldDivCurrent.fadeOut(300, function () { if (!oldDivCurrent.is(dxCtrlMobile.element()) && !oldDivCurrent.is($DivCurrent)) oldDivCurrent.empty() })
    //    $DivCurrent = $DivContentSmsVue
    //    $("<div style='width:100%;height:100%;'/>").appendTo($DivCurrent).dxCtrlGridComDestinataireTrackingVueSms({
    //        bddCtrl: option.bddCtrl,
    //        lstLstConditionBase: [[{ nom_champ: "id_com_sms_envoi", ope: "=", valeur: [{ value: option.data.id_com_sms_envoi }] }]],
    //        showBtNew: false
    //    })
    //    $DivCurrent.fadeIn(300, function () { jauge.mHide() })
    //}
    //function mRempliClick() {
    //    var oldDivCurrent = $DivCurrent
    //    oldDivCurrent.stop()
    //    oldDivCurrent.fadeOut(300, function () { if (!oldDivCurrent.is(dxCtrlMobile.element()) && !oldDivCurrent.is($DivCurrent)) oldDivCurrent.empty() })
    //    $DivCurrent = $DivContentSmsClick
    //    $("<div style='width:100%;height:100%;'/>").appendTo($DivCurrent).dxCtrlGridComDestinataireTrackingClickSms({
    //        bddCtrl: option.bddCtrl,
    //        lstLstConditionBase: [[{ nom_champ: "id_com_sms_envoi", ope: "=", valeur: [{ value: option.data.id_com_sms_envoi }] }]],
    //        showBtNew: false
    //    })
    //    $DivCurrent.fadeIn(300, function () { jauge.mHide() })
    //}
    //function mRempliDesinscription() {
    //    var oldDivCurrent = $DivCurrent
    //    oldDivCurrent.stop()
    //    oldDivCurrent.fadeOut(300, function () { if (!oldDivCurrent.is(dxCtrlMobile.element()) && !oldDivCurrent.is($DivCurrent)) oldDivCurrent.empty() })
    //    $DivCurrent = $DivContentSmsDesinscription
    //    $("<div/>").appendTo($DivCurrent).dxCtrlGridTelSmsListeNoire({
    //        bddCtrl: option.bddCtrl,
    //        lstLstConditionBase: [[{ nom_champ: "id_com_sms_envoi", ope: "=", valeur: [{ value: option.data.id_com_sms_envoi }] }]],
    //        showBtNew: false
    //    })
    //    $DivCurrent.fadeIn(300, function () { jauge.mHide() })
    //}
    //function mRempliBounce() {
    //    var oldDivCurrent = $DivCurrent
    //    oldDivCurrent.stop()
    //    oldDivCurrent.fadeOut(300, function () { if (!oldDivCurrent.is(dxCtrlMobile.element()) && !oldDivCurrent.is($DivCurrent)) oldDivCurrent.empty() })
    //    $DivCurrent = $DivContentSmsBounce
    //    $("<div/>").appendTo($DivCurrent).dxCtrlGridComDestinataire({
    //        bddCtrl: option.bddCtrl,
    //        context_grid: "list_destinataire_bounce_sms",
    //        noDataText: "Aucun destinataire en bounce",
    //        id_table_com: option.bddCtrl.getObjet(option.data).mGetTable().id_table,
    //        id_com: option.bddCtrl.getObjet(option.data).cle(),
    //        typeData: "comdestsms",
    //        lstLstConditionBase: [[{ nom_champ: "type_bounce", ope: "notparmi", valeur: [{ value: -1 }] }]],
    //        allowCheck: false,
    //        showBtNew: false,
    //        orderBounce: true,
    //        showBounce: true,
    //        allowGroup: true,
    //    }).dxCtrlGridComDestinataire("instance")
    //    $DivCurrent.fadeIn(300, function () { jauge.mHide() })
    //}
    //function mRempliMessage() {
    //    var oldDivCurrent = $DivCurrent
    //    oldDivCurrent.stop()
    //    oldDivCurrent.fadeOut(300, function () { if (!oldDivCurrent.is(dxCtrlMobile.element()) && !oldDivCurrent.is($DivCurrent)) oldDivCurrent.empty() })
    //    $DivCurrent = dxCtrlMobile.element()
    //    $DivCurrent.css("display", "flex")
    //    jauge.mHide()
    //}

    var firstLoad = true
    //var dxTagBoxDest = null
    //function mRempliDest(funcOk) {
    //    $DivEntete.empty()
    //    dxTagBoxDest = $("<div style='margin:0 10px;'/>").appendTo($DivEntete).dxCtrlTagBoxDestinataireSms({
    //        bddCtrl: option.bddCtrl,
    //        data: option.data,
    //        readOnly: (option.data.date_envoi != null),
    //        funcSave: function (funcSaved) {
    //            Me.mSaveAuto(function () { funcSaved() }, true)
    //            mRempliBt()
    //        },
    //        onChange: function () {
    //            mRempliBt()
    //        },
    //        onDemandeGestion: function () {
    //            var obj = option.bddCtrl.getObjet(option.data)
    //            if (obj.cle() == null) {
    //                obj.mSave(function () { mDisplayGestionAdresseEnvoi() })
    //            } else { mDisplayGestionAdresseEnvoi() }
    //        },
    //        onContentReady: function () {
    //            if (typeof funcOk != 'undefined') funcOk()
    //        }
    //    }).dxCtrlTagBoxDestinataireSms("instance")
    //    $("<hr style='opacity:0.3'/>").appendTo($DivEntete)
    //}

    var nbCaractereOld = null
    var nbCreditOld = null
    var txtSaved = null
    //function mChange() {
    //    if (container.closest("body").length = 0) return
    //    var txt = $TxtAreaEmoji.getText()
    //    if (txt == null) txt = ""
    //    var sendSms = new cSendSms(option.bddCtrl, txt, option.data.ajout_stop == "1")
    //    option.data.body_txt = sendSms.mGetTextSmsWithSeparateurLink()
    //    var nbCaractereNew = sendSms.mGetNbCaractereMessage()
    //    var nbCreditNew = sendSms.mGetNbCredit1MessageFrance()
    //    if (nbCaractereNew != nbCaractereOld || nbCreditNew != nbCreditOld) {
    //        if ($TxtAreaEmoji != null) {
    //            if (option.data.body_txt.length == 0) {
    //                $DivDetail.empty()
    //                nbCaractereOld = 0
    //                nbCreditOld = 0
    //            } else {
    //                nbCaractereOld = nbCaractereNew
    //                nbCreditOld = nbCreditNew
    //                $DivDetail.empty()
    //                var $DivPlus = $("<div style='position:relative;width:100%;text-align:center;'/>").appendTo($DivDetail)
    //                if (nbCaractereOld > sendSms.mGetMaxCar()) $("<i class='fas fa-triangle-exclamation blinkscalealways' style='display:inline-block;z-index:5;font-size:400%;color:red;opacity:0.5;position:absolute;text-align:center;left:calc(50% - 30px);'></i>").appendTo($DivPlus)
    //                var $DivTab = $("<div style='position:relative;height:32px;margin-bottom:5px;'/>").appendTo($DivPlus)
    //                var $Table = $("<table style='width:100%;position:absolute;z-index:2;'/>").appendTo($DivTab)
    //                var $Tr = $("<tr/>").appendTo($Table)
    //                var css = "border:" + theme.border + ";width:" + (100 / 6) + "%;padding:4px 0;"
    //                var $Td = $("<td style='" + css + ((nbCreditOld >= 1) ? "background-color:LightBlue;" : "") + "'>1 sms</td>").appendTo($Tr)
    //                var $Td = $("<td style='" + css + ((nbCreditOld >= 2) ? "background-color:LightBlue;" : "") + "'>2 sms</td>").appendTo($Tr)
    //                var $Td = $("<td style='" + css + ((nbCreditOld >= 3) ? "background-color:LightBlue;" : "") + "'>3 sms</td>").appendTo($Tr)
    //                var $Td = $("<td style='" + css + ((nbCreditOld >= 4) ? "background-color:LightBlue;" : "") + "'>4 sms</td>").appendTo($Tr)
    //                var $Td = $("<td style='" + css + ((nbCreditOld >= 5) ? "background-color:LightBlue;" : "") + "'>5 sms</td>").appendTo($Tr)
    //                var $Td = $("<td style='" + css + ((nbCreditOld >= 6) ? "background-color:LightBlue;" : "") + "'>6 sms</td>").appendTo($Tr)
    //                var widthPercent = (nbCaractereOld * (100 / sendSms.mGetMaxCar()))
    //                var $DivJauge = $("<div style='position:absolute;background-color:navy;opacity:0.5;height:100%;width:calc(" + ((widthPercent > 100) ? 100 : widthPercent) + "% - 0px);z-index:3;'/>").appendTo($DivTab)
    //                var $DivNbCarSms = $("<div>" + sendSms.mGetNbCarBySms() + " caractères par SMS</div>").appendTo($DivPlus)
    //                if (sendSms.isUniCode()) {
    //                    $("<span style='opacity:0.3;'> &bull; (" + sendSms.nbCarBySmsString + " sans émoji😥)</span>").appendTo($DivNbCarSms)
    //                    $DivNbCarSms.attr("title", "Vous utilisez des emojis, des langues non latines (Arabe, Chinois, Russe, etc) dans votre message.<br/>Attention! Le nombre de caractères possible par SMS passe de " + option.bddCtrl.getObjet("com_sms_envoi").objetMetier.nbCarBySmsString + " à " + option.bddCtrl.getObjet("com_sms_envoi").objetMetier.nbCarBySmsUnicode + "!<br/>Afin d‘éviter les soucis d'encodage avec certains téléphones, il faut mettre des espaces devant les emojis")
    //                }
    //                var $DivTxt = null
    //                if (dxTagBoxDest.mGetLstDestinataire().length == 1 && dxTagBoxDest.mGetLstDestinataire()[0].tel_code_pays != null) {
    //                    var indic = parametre.lstIndicatifTel.filter(function (o) { return o.code == dxTagBoxDest.mGetLstDestinataire()[0].tel_code_pays })[0]
    //                    var nbCredit = sendSms.mGetNbCredit1Message(dxTagBoxDest.mGetLstDestinataire()[0].tel_code_pays, true)
    //                    //var nbCredit = option.bddCtrl.getObjet(dxTagBoxDest.mGetLstDestinataire()[0]).objetMetier.mGetCalculNbCreditToUseFromCodePays(nbCreditOld)
    //                    $DivTxt = $("<div>" + nbCaractereOld + " car" + ((nbCaractereOld > 1) ? "s" : "") + " soit <b" + ((nbCredit >= 2) ? " style = 'color:red'" : "") + "> " + nbCredit + "</b> sms/destinataire <span style='font-size:70%;opacity:0.3;'>(" + indic.name + ")</span> </div>").appendTo($DivPlus)
    //                } else {
    //                    //plusieurs dest
    //                    //on met pas de détails
    //                    $DivTxt = $("<div>" + nbCaractereOld + " car" + ((nbCaractereOld > 1) ? "s" : "") + " soit <b" + ((nbCreditOld >= 2) ? " style = 'color:red'" : "") + "> " + nbCreditOld + "</b> sms" + ((nbCreditOld > 1) ? "s" : "") + "/destinataire <span style='font-size:70%;opacity:0.3;'>(France métropolitaine)</span> </div>").appendTo($DivPlus)
    //                }
    //                var $A = $("<a href='javascript:void(0)' title='Tarif des SMS par pays' style='font-size:80%'>Détails</a>").appendTo($DivTxt)
    //                $A.on("click", function () {
    //                    var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
    //                        width: 250,
    //                        target: $A,
    //                        contentTemplate: function (contentElement) {
    //                            contentElement.css("padding", "15px")
    //                            var sendSms = new cSendSms(option.bddCtrl)
    //                            sendSms.mGetDivTarifSmsParPays(contentElement)
    //                        }
    //                    }).dxCtrlTooltip("instance")
    //                    tt.show()
    //                })
    //                //var $DivTxt = $("<div style='opacity:0.3'>" + dxTagBoxDest.mGetLstDestinataire().length + " destinataire" + ((dxTagBoxDest.mGetLstDestinataire() > 1) ? "s" : "") + " - " + mGetTotalCredits() + " crédits</div>").appendTo($DivPlus)
    //                //var $DivTxt = $("<div style='opacity:0.3'>" + mGetDetailCreditHtml() + "</div>").appendTo($DivPlus)
    //            }
    //        } else { $DivDetail.empty() }
    //        option.bddCtrl.getObjet(option.data).mSaveChamp("body_txt", function () {
    //            window.setTimeout(function () { mChange() }, 1000)
    //        })
    //    } else {
    //        window.setTimeout(function () { mChange() }, 1000)
    //    }
    //}

    var lstItemToolBarSource = null
    function mRempliBt() {

        if (typeof option.optionPopup == 'undefined') option.optionPopup = {}
        if (typeof option.optionPopup.toolbar == 'undefined' || option.optionPopup.toolbar == null) {
            option.optionPopup.toolbar = $("<div/>").appendTo(container).dxToolbar({
                width: "100%",
                items: [],
                onContentReady: function (e) {
                    e.component.element().find(".dx-toolbar-after").addClass("dx-surface")
                }
            }).dxToolbar("instance")
        } else {
            var lstIt = option.optionPopup.toolbar.option("items")
            var lstDel = []
            lstIt.forEach(function (it) { if (it.cssClass != "initial") lstDel.push(it) })
            lstDel.forEach(function (it) { lstIt.splice(lstIt.indexOf(it), 1) })
            option.optionPopup.toolbar.option("items", lstIt)
        }


        var itemsToolbar = []
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div style=''/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-copy",
                    txtTooltip: "Dupliquer",
                    onClick: function (e) {

                        if (!option.bddCtrl.objCptCli.objetMetier.hasSms()) {
                            mNotify("Vous n'avez pas les smsm dans votre offre", "error", 10000)
                            return
                        }
                        if (option.data.id_com_sms_envoi == null) {
                            dxContentEmailEnvoi.dxContentEmailBase.mSaveAuto(function () { mLanceDuplik() }, option.bddCtrl.getObjet(option.data).cle() == null)
                        } else { mLanceDuplik() }

                        function mLanceDuplik() {
                            var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                                width: 400,
                                target: e.component.element(),
                                contentTemplate: function (contentElement) {
                                    contentElement.css("padding", "24px")
                                    $("<div/>").appendTo(contentElement).dxCtrlButton({
                                        text: "Dupliquer sans destinataire",
                                        width: "100%",
                                        onClick: function (e) {
                                            mDuplik("0")
                                            tt.hide()
                                        }
                                    });
                                    $("<br/>").appendTo(contentElement)
                                    $("<div/>").appendTo(contentElement).dxCtrlButton({
                                        text: "Dupliquer avec destinataire",
                                        width: "100%",
                                        onClick: function (e) {
                                            mDuplik("1")
                                            tt.hide()
                                        }
                                    });
                                }
                            }).dxCtrlTooltip("instance");
                            tt.show();

                            function mDuplik(avecDestinataire) {
                                option.bddCtrl.mAjaxCall({ command: "dupliksmsenvoi", id_com_sms_envoi: option.data.id_com_sms_envoi, avec_destinataire: avecDestinataire }, function (data) {
                                    page.mAddPopup(option.bddCtrl.getObjet("com_sms_envoi", data.id_com_sms_envoi).data)
                                })
                                page.mRemovePopup(option.data)
                            }

                        }
                    }
                });
            },
        })
        itemsToolbar.push(getToolbarSeparator())

        if (option.data.date_envoi == null || option.data.id_type_classement == 11) {
            itemsToolbar.push({
                location: 'after',
                locateInMenu: 'auto',
                template(itemData, itemIndex, itemElement) {
                    var opt = {
                        icon: "fas fa-paper-plane",
                        icon2: "fas fa-vial",
                        colorIcone2: theme.colorBtIcon2,
                        opacityIcone2: "0.9",
                        txtTooltip: "Tester votre message en l'envoyant<br/>sur un numéro de mobile.",
                        onClick: function (e) {
                            var sendSms = new cSendSms(option.bddCtrl, option.data.body_txt, option.data.ajout_stop == "1")
                            if (!option.bddCtrl.isDemo && sendSms.mGetNbCredit1MessageFrance(false) > option.bddCtrl.objCptCli.objetMetier.mGetNbSmsDispo()) {
                                option.bddCtrl.objCptCli.objetMetier.mSignaleLimiteAbonnement(itemElement, "Vous ne disposez pas<br/>de suffisament de crédit SMS<br/>pour votre test.<br/>Accédez à votre compte<br/>pour acheter des packs SMS.", "Acheter des crédits", 3, function () {
                                    $("<div/>").appendTo("body").dxCtrlAchatPopup({
                                        bddCtrl: option.bddCtrl,
                                        typeProduit: "credit_sms",
                                        nb: sendSms.mGetNbCredit1MessageFrance(false),
                                        onPaiement: function () {
                                            jaugeDemarrage.mHide()
                                            option.bddCtrl.mReloadTable("credit_sms", function () {
                                                jaugeDemarrage.mHide()
                                            })
                                        }
                                    })
                                })
                            } else {
                                $("<div/>").appendTo("body").dxCtrlPopupSaisieTelTest({
                                    bddCtrl: option.bddCtrl,
                                    sendSms: sendSms,
                                    nbCaractereMessage: sendSms.mGetNbCaractereMessage(false),
                                    nbCreditMessage: sendSms.mGetNbCredit1MessageFrance(false),
                                    isUniCode: sendSms.isUniCode(),
                                    onValidate: function (codePays, valeur) {
                                        jauge.option("onCancel", function () { })
                                        jauge.mShow();
                                        jauge.option("message", "Génération et envoi du sms de test")
                                        option.bddCtrl.getObjet("com_sms_envoi", option.data.id_com_sms_envoi).objetMetier.mSendSmsTest(codePays, valeur, sendSms.mGetNbCredit1MessageFrance(false), jauge, function () {
                                            mNotify("Vous êtes dans un environnement de démo<br/>L'envoi de votre sms a été simulé et celui-ci n'a pas été réellement envoyé", "warning", 6000)
                                            jauge.mHide();
                                            jauge.option("onCancel", null)
                                        })
                                        //bdd.mAjaxCall({ command: "sendsmstest", text: $TxtAreaEmoji.getText(), code_pays: codePays, tel_num: valeur }, function (data) {
                                        //    if (data.ok == "1") {
                                        //        mNotify("Votre sms de test a été envoyé.", "success", 6000)
                                        //    } else {
                                        //        mNotify("Impossible d'envoyer votre SMS de test", "error", 6000)
                                        //    }
                                        //})
                                    }
                                })
                            }
                        }
                    }
                    $("<div/>").appendTo(itemElement).dxCtrlButton(opt);
                },
            })
            //itemsToolbar.push({
            //    location: 'after',
            //    locateInMenu: 'auto',
            //    template(itemData, itemIndex, itemElement) {
            //        var opt = {
            //            icon: "fas fa-paper-plane",
            //            txtTooltip: "Envoyer",
            //            icon2: "fas fa-cog",
            //            colorIcone2: theme.colorBtIcon2,
            //            opacityIcone2: "0.9",
            //            icon3: "fas fa-question",
            //            colorIcone3: theme.color,
            //            txtTooltip: "Ouvrir la gestion des destinataires<br/>et la configuration d'envoi.",
            //            leftIcone3: true,
            //            onClick: function (e) {
            //                var sendSms = new cSendSms(option.bddCtrl, option.data.body_txt)
            //                if (sendSms.mGetNbCaractereMessage() > sendSms.mGetMaxCar()) {
            //                    mNotify("Votre SMS est trop long pour être envoyé", "error", 6000)
            //                } else {
            //                    mDisplayGestionAdresseEnvoi(function (lstDestNettoye) {
            //                        mSend()
            //                        page.mRemovePopup(option.data)
            //                    })
            //                }
            //            }
            //        }
            //        $("<div/>").appendTo(itemElement).dxCtrlButton(opt);
            //    },
            //})
            //itemsToolbar.push(getToolbarSeparator())
            //itemsToolbar.push({
            //    location: 'after',
            //    locateInMenu: 'auto',
            //    template(itemData, itemIndex, itemElement) {
            //        var opt = {
            //            icon: "fas fa-paper-plane",
            //            icon2: "fas fa-bullseye",
            //            colorIcone2: theme.colorBtIcon2,
            //            opacityIcone2: "0.9",
            //            txtTooltip: "Envoyer votre email en tracking",
            //            onClick: function (e) {
            //                var sendSms = new cSendSms(option.bddCtrl, option.data.body_txt)
            //                if (sendSms.mGetNbCaractereMessage() > sendSms.mGetMaxCar()) {
            //                    mNotify("Votre SMS est trop long pour être envoyé", "error", 6000)
            //                } else {
            //                    option.data.tracking = "1"
            //                    option.bddCtrl.getObjet(option.data).mSaveChamp("tracking", function () {
            //                        Me.mSaveAuto(function () {
            //                            mSendSms(e.component.element())
            //                        })
            //                    })
            //                }
            //            }
            //        }
            //        $("<div/>").appendTo(itemElement).dxCtrlButton(opt);
            //    },
            //})
            //itemsToolbar.push({
            //    location: 'after',
            //    locateInMenu: 'auto',
            //    template(itemData, itemIndex, itemElement) {
            //        opt = {
            //            icon: "fas fa-paper-plane",
            //            txtTooltip: "Envoyer",
            //            onClick: function (e) {
            //                var sendSms = new cSendSms(option.bddCtrl, option.data.body_txt)
            //                if (sendSms.mGetNbCaractereMessage() > sendSms.mGetMaxCar()) {
            //                    mNotify("Votre SMS est trop long pour être envoyé", "error", 6000)
            //                } else {
            //                    option.data.tracking = "0"
            //                    option.bddCtrl.getObjet(option.data).mSaveChamp("tracking", function () {
            //                        Me.mSaveAuto(function () {
            //                            mSendSms(e.component.element())
            //                        })
            //                    })
            //                }
            //            }
            //        }
            //        $("<div/>").appendTo(itemElement).dxCtrlButton(opt);
            //    },
            //})
        }
        itemsToolbar.push(getToolbarSeparator())
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-trash-alt",
                    txtTooltip: "Mettre à la corbeille",
                    onClick: function (e) {
                        var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                            target: e.component.element(),
                            contentTemplate: function (contentElement) {
                                contentElement.css("padding", "25px")
                                $("<div style='padding-bottom:15px;'>Mettre le message<br/>à la corbeille</div>").appendTo(contentElement)
                                $("<div/>").appendTo(contentElement).dxCtrlButton({
                                    text: "Confirmez",
                                    onClick: function (e) {
                                        tt.hide()
                                        option.bddCtrl.getObjet(option.data).mDelData()
                                        page.mRemovePopup(option.data)
                                    }
                                })
                            }
                        }).dxCtrlTooltip("instance");
                        tt.show();
                    }
                });
            },
        })

        itemsToolbar.reverse()
        if (!lstItemToolBarSource) lstItemToolBarSource = option.optionPopup.toolbar.option("items").slice()
        var lstItems = lstItemToolBarSource.slice()
        itemsToolbar.forEach(function (itemT) { lstItems.unshift(itemT) })
        option.optionPopup.toolbar.option("items", lstItems)

    }

    //function mDisplayGestionAdresseEnvoi(onDemandeEnvoi) {
    //    $("<div/>").dxCtrlGestionDestConfigEnvoi({
    //        bddCtrl: option.bddCtrl,
    //        container: ((container.closest(".dx-popup-normal").length > 0) ? $(container.closest(".dx-popup-normal")[0]) : ((container.closest(".dx-ctrlpagepopupdiv").length > 0) ? $(container.closest(".dx-ctrlpagepopupdiv")[0]) : container)),
    //        type: "mobile",
    //        data: option.data,
    //        id_table_com: option.bddCtrl.getObjet(option.data).mGetTable().id_table,
    //        id_com: option.data.id_com_sms_envoi,
    //        onDemandeEnvoi: onDemandeEnvoi,
    //        onClose: function () { mRempliDest() }
    //    })
    //}

    //function mSendSms(target) {
    //    if (dxTagBoxDest.mGetLstDestinataire().length == 0) {
    //        mNotify("Votre sms doit comporter au moins un destinataire", "warning", 8000)
    //        dxTagBoxDest.dxTagBoxDest.focus()
    //    } else if (option.data.body_txt == null || option.data.body_txt.length == 0) {
    //        mNotify("Votre message est vide", "warning", 8000)
    //        $TxtAreaEmoji.setFocus()
    //    } else {
    //        //on vérifie les destinataires
    //        //if (verifDest) {
    //        option.bddCtrl.mAjaxCall({
    //            command: "getlstdestcomforgestion",
    //            id_table_com: option.bddCtrl.getObjet(option.data).mGetTable().id_table,
    //            id_com: option.data.id_com_sms_envoi,
    //            type: "mobile"
    //        }, function (data) {
    //            if (typeof data.lst_com_destinataire == 'undefined') data.lst_com_destinataire = []
    //            if (data.lst_com_destinataire.length >= 2) {
    //                option.data.tracking = "1"
    //                option.bddCtrl.getObjet(option.data).mSave()
    //            }
    //            var lstToDel = option.bddCtrl.getObjet("com_destinataire").objetMetier.mNettoieDoublonSansAdresse(data.lst_com_destinataire)
    //            if (lstToDel.length > 0) {
    //                mNotify("La liste de vos destinataires présente des incohérences", "warning", 4000)
    //                mDisplayGestionAdresseEnvoi(function (lstDestNettoye) {
    //                    mSend(lstDestNettoye)
    //                    page.mRemovePopup(option.data)
    //                })
    //            } else {
    //                //les destinataires sont nettoyé
    //                if (data.lst_com_destinataire.length >= 2) {
    //                    mDisplayGestionAdresseEnvoi(function (lstDestNettoye) {
    //                        mSend(lstDestNettoye)
    //                        page.mRemovePopup(option.data)
    //                    })
    //                } else {
    //                    option.bddCtrl.getObjet(option.data).objetMetier.mGetCalculTotalCreditToUse(function (nbCreditTotal) {
    //                        if (option.bddCtrl.isDemo) {
    //                            mNotify("Vous êtes dans un environnement de démo<br/>L'envoi de votre sms sera simulé et celui-ci ne sera pas réellement envoyé", "warning", 6000)
    //                            mSend(data.lst_com_destinataire)
    //                            page.mRemovePopup(option.data)
    //                        } else if (nbCreditTotal > option.bddCtrl.objCptCli.objetMetier.mGetNbSmsDispo()) {
    //                            option.bddCtrl.objCptCli.objetMetier.mSignaleLimiteAbonnement(target, "Vous ne disposez pas<br/>de suffisament de crédit SMS.<br/>Accédez à votre compte<br/>pour acheter des packs SMS.", "Acheter des crédits", 3, function () {
    //                                $("<div/>").appendTo("body").dxCtrlAchatPopup({
    //                                    bddCtrl: option.bddCtrl,
    //                                    typeProduit: "credit_sms",
    //                                    nb: nbCreditTotal,
    //                                    onPaiement: function () {
    //                                        jaugeDemarrage.mHide()
    //                                        option.bddCtrl.mReloadTable("credit_sms", function () {
    //                                            jaugeDemarrage.mHide()
    //                                        })
    //                                    }
    //                                })
    //                            })
    //                        } else {
    //                            mSend(data.lst_com_destinataire)
    //                            page.mRemovePopup(option.data)
    //                        }
    //                    })
    //                }
    //            }
    //        })
    //    }

    //    function mSend(lstDestinataire) {
    //        //on enregistre les crédits de chaque message
    //        option.bddCtrl.getObjet(option.data).objetMetier.mSend(function () {
    //            page.mRemovePopup(option.data)
    //        })
    //    }
    //}

    //this.isDirty = function (dirty) {
    //    if (typeof dirty != 'undefined') {
    //        if (dirty) { txtSaved = null }
    //        else { txtSaved = $TxtAreaEmoji.getText() }
    //    }
    //    return txtSaved != $TxtAreaEmoji.getText()
    //}

    //function mStartSaveAuto() {
    //    timeOutSaveAuto = window.setTimeout(function () { Me.mSaveAuto() }, 10000)
    //    var popupPage = null
    //    if (typeof page.mGetPopupPage != 'undefined') popupPage = page.mGetPopupPage(option.data)
    //    if (popupPage != null) {
    //        var onclose = popupPage.option("onClose")
    //        popupPage.option("onClose", function (e, funcFin) {
    //            Me.mStopSaveAuto(function () {
    //                if (typeof onclose != 'undefined') onclose(e)
    //                if (typeof funcFin != 'undefined') funcFin()
    //            })
    //        })
    //    }

    //    //if ($("body").find("." + container.closest(".dx-popup-content").attr("idpopup")).length > 0) {
    //    //    var popup = $("body").find("." + container.closest(".dx-popup-content").attr("idpopup")).dxPopup("instance")
    //    //    var onhiding = popup.option("onHiding")
    //    //    var firstHide = true
    //    //    popup.option("onHiding", function (e) {
    //    //        if (firstHide) {
    //    //            firstHide = false
    //    //            e.cancel = true
    //    //            Me.mStopSaveAuto(function () {
    //    //                window.setTimeout(function () { popup.hide() }, 0)
    //    //            })
    //    //        } else {
    //    //            if (typeof onhiding != 'undefined') onhiding(e)
    //    //        }
    //    //    })
    //    //}
    //}
    //var saveAuto = true
    //this.mStopSaveAuto = function (funcFin) {
    //    saveAuto = false
    //    window.clearTimeout(timeOutSaveAuto)
    //    this.mSaveAuto(funcFin)
    //}
    //var timeOutSaveAuto = null
    //this.mSaveAuto = function (funcFin, forcer) {
    //    if (typeof forcer == "undefined") forcer = false
    //    window.clearTimeout(timeOutSaveAuto)
    //    if (Me.isDirty() || forcer) {
    //        Me.mSave(function (parametre) {
    //            if (typeof funcFin != 'undefined') funcFin(parametre)
    //            if (saveAuto && container.closest("body").length > 0) timeOutSaveAuto = window.setTimeout(function () { Me.mSaveAuto() }, 10000)
    //        })
    //    } else {
    //        if (typeof funcFin != 'undefined') funcFin()
    //        if (saveAuto && container.closest("body").length > 0) timeOutSaveAuto = window.setTimeout(function () { Me.mSaveAuto() }, 10000)
    //    }
    //}
    //this.mSave = function (funcFin) {
    //    if ($TxtAreaEmoji == null) { window.setTimeout(function () { Me.mSave(funcFin) }, 100) }
    //    else {
    //        Me.isDirty(false)
    //        var txt = $TxtAreaEmoji.getText()
    //        var sendSms = new cSendSms(option.bddCtrl, txt, option.data.ajout_stop == "1")
    //        option.data.body_txt = sendSms.mGetTextSmsWithSeparateurLink()
    //        option.bddCtrl.getObjet(option.data).mSave(function (data) {
    //            funcFin(data)
    //        })
    //    }
    //}

    this.focus = function () { }

    this.element = function () { return container }

    mConstruit();
}